import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { OCPPRemoteStopTransactionRequestModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/ocpp/remote-stop-transaction.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useStopChargePointChannelTransactionContext } from '../../charge-point.context';
import { ChargePointChannelTransactionStopFormStep1Controller } from '../charge-point-channel-transaction-stop-form-step-1/charge-point-channel-transaction-stop-form-step-1.controller';

export interface ChargePointChannelTransactionStopFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<OCPPRemoteStopTransactionRequestModel, 'chargePointId' | 'channelId'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<OCPPRemoteStopTransactionRequestModel, 'chargePointId' | 'channelId'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const ChargePointChannelTransactionStopFormController = (
  props: ChargePointChannelTransactionStopFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useStopChargePointChannelTransactionContext();

  return (
    <MultiStepFormProvider<
      Pick<OCPPRemoteStopTransactionRequestModel, 'chargePointId' | 'channelId'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['chargePointId', 'channelId'],
          component: <ChargePointChannelTransactionStopFormStep1Controller />,
        },
      ]}
    />
  );
};
